<template>
  <div class="report-list-container">
    <template v-if="list.length">
      <van-list v-model="loading" :finished="finished" @load="loadMore" finished-text="没有更多了">
        <div class="log-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
          <div class="log-text">
            <p>{{item.shop}}&nbsp;&nbsp;{{item.type | typeFilter}}</p>
            <span>{{item.createTime}}</span>
          </div>
          <img src="../../../assets/icon/icons8-right_4@2x.png">
          <div v-if="item.status === 0" class="award-label">待处理</div>
          <div v-else-if="item.status === 1" class="award-label">处理中</div>
          <div v-else class="award-label await">已处理</div>
        </div>
      </van-list>
    </template>
    <template v-else>
      <p class="blank">暂无纪录</p>
    </template>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { List } from 'vant'
Vue.use(List)

export default {
  name: 'ReportList',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      totalPage: 1
    }
  },
  created() {
    this.getList()
  },
  filters: {
    typeFilter(type) {
      const typeMap = {
        0: '假货',
        1: '窜货'
      }
      return typeMap[type]
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token'])
  },
  methods: {
    getList() {
      var that = this
      var params = { page: this.page + 1 }
      this.axios.get('/antifake/report/?user_id=' + this.userInfo.id + '&desc=create_time', { params: params }).then(function(res) {
        console.log(res.data.records)
        that.loading = false
        that.list = that.list.concat(res.data.records)
        that.page = res.data.current
        that.totalPage = res.data.pages
      }).catch(function(error) {
        console.log(error)
      })
    },
    loadMore() {
      if (this.totalPage === this.page) {
        this.finished = true
        this.loading = false
      } else {
        this.getList()
      }
    },

    /**
     * 查看举报详情
     */
    toDetail(item) {
      this.$router.push({ name: 'ReportDetail', params: { id: item.id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.report-list-container{
  .log-item{
    height: 40px;
    padding: 20px 20px 20px 30px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1px;
    position: relative;
    .log-text{
      p{
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
      span{
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    img{
      width: 6px;
      height: 10px;
    }
    .award-label{
      position: absolute;
      top: 0;
      right: 0;
      width: 60px;
      height: 20px;
      border-radius: 0 0 0 13px;
      background-color: #5e5ef6;
      // opacity: 0.3;
      color: white;
      font-size: 10px;
      font-weight: 600;
      line-height: 20px;
      text-align: center;
    }
    .await{
      color: #ffffff;
      background-color: #ff6d63;
      opacity: 0.8;
    }
  }
  .blank{
    text-align: center;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: 400;
    margin: 245px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/report/index.vue